import { DropdownItem } from "@flixbus/honeycomb-react";
import * as React from "react";
import App from "../../types";
import getHelpMenuItems from "../getHelpMenuItems/getHelpMenuItems";

const getDropdownHelpMenuItems = (app: App) => {
  const items = getHelpMenuItems(app, true);

  const dropdownItems = items.map((item) => (
    <DropdownItem
      key={item.key}
      InlineIcon={item.InlineIcon}
      href={item.href}
      to={item.to}
      target={item.target}
      RouterLink={item.RouterLink}
    >
      {item.text}
    </DropdownItem>
  ));

  if (dropdownItems.length > 1) {
    return [...dropdownItems.slice(0, 1), <DropdownItem key="divider" divider />, ...dropdownItems.slice(1)];
  }

  return dropdownItems;
};

export default getDropdownHelpMenuItems;
